import { render } from "./UserSwitcher.vue?vue&type=template&id=7c780ff4"
import script from "./UserSwitcher.vue?vue&type=script&lang=js"
export * from "./UserSwitcher.vue?vue&type=script&lang=js"

import "./UserSwitcher.vue?vue&type=style&index=0&id=7c780ff4&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__